/**
 * The campaign's books, played. Book One is Tale 1 (World 1): its chapters, battles, pages and
 * picture briefs all come from `story/book-1-the-purple-egg.md` through `book1.generated.ts`.
 */
import { BOOK_1 } from './book1.generated.js';
import { bookBattles, bookDraftChapters, bookLines, bookPages, bookScenes, bookTale, bookZones } from './fromBook.js';

export { BOOK_1 };

export const BOOK_1_ZONES = bookZones(BOOK_1);
export const BOOK_1_TALE = bookTale(BOOK_1);
export const BOOK_1_PAGES = bookPages(BOOK_1);
export const BOOK_1_BATTLES = bookBattles(BOOK_1);
export const BOOK_1_SCENES = bookScenes(BOOK_1);
export const BOOK_1_DRAFT_CHAPTERS = bookDraftChapters(BOOK_1);
export const BOOK_1_LINES = Object.fromEntries(BOOK_1_PAGES.map((p) => [p.id, bookLines(BOOK_1, p)]));
